import React, { useState, useEffect } from "react";
import "../../../styles/Auth/report.css";
import { useNavigate, useLocation } from 'react-router-dom';
import { useStore } from "../../../Context/context.jsx";
import { Icon } from "@iconify/react";
import StoreSingleAllStoresSelect, { STORE_OPTION, ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import { getDateRange } from "../../../utils/get-DateRange.js";

const ReportHeader = ({ startDate, setStartDate, endDate, setEndDate, dateRange, setDateRange }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem("role");
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [store, setStore] = useState(ALL_STORE_OPTION);

    useEffect(() => {
        if (["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role)) {
            setSelectedStoreId("");
        }
    }, [role, setSelectedStoreId]);

    const activeReport = location.pathname.split("/").pop();

    return (
        <div className="report-main-header-box">
            {/* <div className="Report-Header">
                <div
                    className={activeReport === "summary" ? "active" : ""}
                    onClick={() => navigate("/reports/summary")}
                >
                    Summary Report
                </div>
                <div
                    className={activeReport === "earning" ? "active" : ""}
                    onClick={() => navigate("/reports/earning")}
                >
                    Earning Report
                </div>
                <div
                    className={activeReport === "sales" ? "active" : ""}
                    onClick={() => navigate("/reports/sales")}
                >
                    Sales Report
                </div>
                <div
                    className={activeReport === "graph" ? "active" : ""}
                    onClick={() => navigate("/reports/graph")}
                >
                    Graph Report
                </div>
                <div
                    className={activeReport === "customer" ? "active" : ""}
                    onClick={() => navigate("/reports/customer")}
                >
                    Customer Report
                </div>
                <div
                    className={activeReport === "eod" ? "active" : ""}
                    onClick={() => navigate("/reports/eod")}
                >
                    End of Day Report
                </div>

            </div> */}

            <div className="report-header-controls">
                <div className="report-filters-group">
                    {activeReport === "eod" ? (
                        <div style={{
                            padding: '10px 16px',
                            background: '#f8fafc',
                            borderRadius: '12px',
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#3C0008',
                            border: '1px solid #e2e8f0',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <Icon icon="mdi:calendar" width="20" />
                            {(() => {
                                const parseDateSafe = (dateStr) => {
                                    if (!dateStr) return new Date();
                                    const cleanDateStr = dateStr.split('T')[0];
                                    const [year, month, day] = cleanDateStr.split('-').map(Number);
                                    return new Date(year, month - 1, day);
                                };
                                const displayDate = parseDateSafe(startDate);
                                const isToday = displayDate.toDateString() === new Date().toDateString();
                                const yesterday = new Date();
                                yesterday.setDate(yesterday.getDate() - 1);
                                const isYesterday = displayDate.toDateString() === yesterday.toDateString();
                                const label = isToday ? 'Today' : (isYesterday ? 'Yesterday' : 'Date');
                                return `${label}: ${displayDate.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}`;
                            })()}
                        </div>
                    ) : (
                        <>
                            <select
                                className="report-select-input"
                                value={dateRange}
                                onChange={e => {
                                    const range = e.target.value;
                                    setDateRange(range);
                                    const { startDate: s, endDate: eD } = getDateRange(range, startDate, endDate);
                                    setStartDate(s);
                                    setEndDate(eD);
                                }}
                            >
                                <option value="Today">Today</option>
                                <option value="Yesterday">Yesterday</option>
                                <option value="Last 7 Days">Last 7 Days</option>
                                <option value="Last Month">Last Month</option>
                                <option value="Current Month">Current Month</option>
                                <option value="Custom">Custom Date</option>
                                <option value="Current FY">Current FY</option>
                                <option value="Previous FY">Previous FY</option>
                            </select>

                            {dateRange === "Custom" && (
                                <>
                                    <input
                                        type="date"
                                        className="report-date-input"
                                        value={startDate}
                                        onChange={e => setStartDate(e.target.value)}
                                    />
                                    <input
                                        type="date"
                                        className="report-date-input"
                                        value={endDate}
                                        onChange={e => setEndDate(e.target.value)}
                                    />
                                </>
                            )}
                        </>
                    )}
                </div>



                {["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) && (
                    <div className="report-header-store-select">
                        <StoreSingleAllStoresSelect
                            value={store}
                            onChange={(opt) => {
                                setStore(opt);
                                setSelectedStoreId(opt?.value || "");
                            }}
                            showAll={true}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ReportHeader;

